import { gql } from '@apollo/client';

export const WHATSAPP_SETTINGS = gql`
  query whatsAppSettings {
    whatsAppSettings {
      configured
      sender
      dryRun
      testSender
    }
  }
`;

export const WHATSAPP_TEMPLATES = gql`
  query whatsAppTemplates {
    whatsAppTemplates {
      sid
      name
      language
      body
      variables
      category
      status
      rejectionReason
    }
  }
`;

export const WHATSAPP_MESSAGES = gql`
  query adminWhatsAppMessages($pagination: PaginationInputType, $direction: WhatsAppDirection, $search: String) {
    adminWhatsAppMessages(pagination: $pagination, direction: $direction, search: $search) {
      total
      messages {
        id
        direction
        phone
        message
        createdAt
        note
        media {
          url
          contentType
        }
        member {
          id
          username
          firstName
          lastName
        }
      }
    }
  }
`;

export const WHATSAPP_AUDIENCE_COUNT = gql`
  query whatsAppAudienceCount($filter: UserFilterInputType) {
    whatsAppAudienceCount(filter: $filter)
  }
`;

// Fields written out rather than shared as a fragment: the tests run
// MockedProvider with addTypename={false}, where a fragment resolves to nothing.
export const WHATSAPP_BROADCAST = gql`
  query whatsAppBroadcast($id: ID!) {
    whatsAppBroadcast(id: $id) {
      id
      templateName
      status
      totalRecipients
      sent
      skipped
      failed
      dryRun
      error
      createdAt
      finishedAt
    }
  }
`;

export const WHATSAPP_BROADCASTS = gql`
  query whatsAppBroadcasts($pagination: PaginationInputType) {
    whatsAppBroadcasts(pagination: $pagination) {
      id
      templateName
      status
      totalRecipients
      sent
      skipped
      failed
      dryRun
      error
      createdAt
      finishedAt
    }
  }
`;
